<template>
  <div class="position-relative">
    <span
      class="playhera-icon mx-4 cursor-pointer"
      @click.prevent="
        $event =>
          openSharingMenu({
            event: $event,
            type: account._type,
            text: `${$filters.displayName(account)} ${$t(
              '_web_' + account._type,
              account._type
            )} on `,
            id: account._id,
            vanityId: account.vanityId,
          })
      "
    >
      <Icon name="share" />
    </span>
    <button
      v-if="permissions.createTournament"
      type="button"
      class="btn-transparent p-2 cursor-pointer text-secondary"
      @click="setActionPopover($event)"
    >
      <Icon name="settings-outline" />
    </button>
    <PopoverMenu
      v-if="statusBarMenuItems.length"
      :closest="$el"
      target-selector="svg"
      :position="actionPopoverPosition"
      :items="statusBarMenuItems"
      :float="['right', 'top']"
    >
      <template slot-scope="{ item }">
        <span
          v-if="item.action"
          :class="{ 'text-danger': item.isDanger }"
          @click="hideActionPopover(item.action)"
          >{{ item.text || item.textCall(clanAccount) }}</span
        >
        <router-link v-else-if="item.link" :to="item.link" class="reset-link">{{
          item.text
        }}</router-link>
      </template>
    </PopoverMenu>
    <!-- <router-link
      :to="{
        name: $routerNames.EDIT,
        params: account.params,
      }"
    >
      <Icon name="settings-outline" :fill="$scss.colors.secondaryTextBg" />
    </router-link> -->
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Icon from '@/components/atoms/Icon';
import PopoverMenu from '@/components/popover/Menu';

import { sharingMenu } from '@/mixins/sharingMenu';
export default {
  name: 'AccountStatusBarActionsEditOrganization',
  components: {
    Icon,
    PopoverMenu,
  },
  mixins: [sharingMenu],
  data() {
    return {
      actionPopoverPosition: null,
    };
  },
  computed: {
    ...mapState('current', ['account']),
    ...mapState('my', { myAccount: 'account' }),
    ...mapGetters([
      'platforms',
      'games',
      'getGamePropById',
      'getPlatformPropById',
      'hasAccessByPermission',
      'permissions',
    ]),
    statusBarMenuItems() {
      return [
        {
          text: this.$t('_web_organization_edit-info', 'Edit info'),
          action: this.goToEdit,
        },
        {
          text: this.$t('_web_organization_manage-admins', 'Manage admins'),
          action: this.goToAdminManagement,
        },
      ];
    },
  },
  methods: {
    hideActionPopover(callback) {
      this.actionPopoverPosition = null;
      if (typeof callback === 'function') {
        callback();
      }
    },
    setActionPopover(event) {
      this.actionPopoverPosition = event.target
        .closest('button')
        .getBoundingClientRect();
    },
    goToEdit() {
      this.$router.push({
        name: this.$routerNames.EDIT,
        params: {
          ...this.account.params,
          ...this.$route.params,
        },
      });
    },
    goToAdminManagement() {
      this.$router.push({
        name: this.$routerNames.SETTINGS,
        params: {
          ...this.account.params,
          ...this.$route.params,
        },
      });
    },
  },
};
</script>
